import { useState, useEffect } from "react";
import {
  Group,
  Container,
  Grid,
  TextInput,
  Center,
  Loader,
  Button,
  Stack,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useLocation } from "wouter";
import { getSingleUser, updateUser } from "../api";

export default function UserEdit({ params }) {
  const [user, setUser] = useState(null);
  const [, setLocation] = useLocation();

  useEffect(() => {
    getSingleUser(params.id).then((data) => {
      setUser(data);
      form.setValues({
        firstName: data.firstName,
        lastName: data.lastName,
        emailAddress: data.emailAddress,
      });
    });
    // Mantine form object has unstable identity; including it would rerun this effect every render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);

  const updateUserHandler = (data) => {
    updateUser(params.id, data).then(() => {
      setLocation(`/users/`);
    });
  };

  const form = useForm({
    mode: "uncontrolled",
  });

  if (!user)
    return (
      <Center mt="xl">
        <Loader size="xl" />
      </Center>
    );

  return (
    <Container size="xs">
      <Grid justify="space-between">
        <Grid.Col span={12}>
          <form onSubmit={form.onSubmit(updateUserHandler)}>
            <Stack>
              <TextInput
                {...form.getInputProps("firstName")}
                key={form.key("firstName")}
                label="First Name"
              />
              <TextInput
                {...form.getInputProps("lastName")}
                key={form.key("lastName")}
                label="Last Name"
              />
              <TextInput
                {...form.getInputProps("emailAddress")}
                key={form.key("emailAddress")}
                label="Email"
              />
              {/*             
            <TextInput
              {...form.getInputProps("description")}
              key={form.key("description")}
              label="Description"
              placeholder="A prompt to find the meaning of life"
            />

            <TagsInput {...form.getInputProps(`tags`)} label="Tags" /> */}

              {/* {form.getValues().tags?.map((item, index) => (
              <Group key={item} mt="xs" align="flex-end">
                <TextInput
                  style={{ flex: 1 }}
                  {...form.getInputProps(`tags.${index}`)}
                  key={form.key(`tags.${index}`)}
                  label="Tag"
                />
                <ActionIcon
                  color="red"
                  variant="outline"
                  onClick={() => form.removeListItem("tags", index)}
                >
                  <IconTrash size="1rem" />
                </ActionIcon>
              </Group>
            ))}

            <Button
              mt="xs"
              onClick={() => form.insertListItem("tags", "")}
            >
              Add Tag
            </Button> */}
              {/* 
            <Textarea
              {...form.getInputProps("promptText")}
              key={form.key("promptText")}
              label="Prompt"
              autosize
              minRows={5}
              maxRows={20}
              radius="md"
            /> */}

              <Group justify="flex-end">
                <Button type="submit" mt="md">
                  Save
                </Button>
              </Group>
            </Stack>
          </form>
        </Grid.Col>
      </Grid>
    </Container>
  );
}
